import createAsyncReducer from '@/store/createAsyncReducer.js';
import Fetch from "~/functions/Fetch.js";

const promptSetsReducer = createAsyncReducer({
    name: 'promptSets',
    initialState: {
        records: {},
        loading: false,
        errorMessage: ''
    },
    reducers: (create) => ({
        loadByPromptable: create.asyncThunk(
            async ({ promptable_type, promptable_id }) => {
                return Fetch.get(Routes.ajax_prompt_sets_path({ promptable_type, promptable_id }));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        ),
        loadById: create.asyncThunk(
            async ({ id }) => {
                return Fetch.get(Routes.ajax_prompt_set_path(id));
            },
            {
                pending: (state, action) => {
                    state.loading = true;
                    state.errorMessage = '';
                },
                fulfilled: (state, action) => {
                    state.loading = false;
                    state.records = { ...state.records, ...action.payload };
                },
                rejected: (state, action) => {
                    state.loading = false;
                    state.errorMessage = action.error;
                }
            }
        ),
    })
});

export default promptSetsReducer;